import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from '../../../../core/util/core/Fetch';

function BankAccount() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/gci/suppliers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'gci/suppliers/saveBankAccount',
        endpointGetById: config.endpoints.backend + 'gci/suppliers/getById',
        endpointGetAllBanks: config.endpoints.backend + 'gci/banks/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleEdit: 'Editar Dados Bancários',
        labelTitleView: 'Visualizar Dados Bancários'
    };

    const getForm = (values) => {
        const form = {
            validateOnChange: true,
            hiddenValues: {
                id: id
            },
            fields: [
                {
                    name: 'gci_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id'
                    },
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    name: 'agency_number',
                    type: 'integer',
                    label: 'Número da Agência',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'agency_digit',
                    type: 'text',
                    label: 'Dígito da Agência (Substitua X por 0)',
                    mask: '9',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'account_number',
                    type: 'integer',
                    label: 'Número da Conta',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'account_digit',
                    type: 'text',
                    label: 'Dígito da Conta (Substitua X por 0)',
                    mask: '9',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'pix_key',
                    type: 'text',
                    label: 'Chave PIX',
                    validations: { required: false },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                const supplier = await Fetch.post(paths.endpointGetById, { id });
                values = {
                    gci_bank_id: supplier.gci_bank_id || '',
                    agency_number: supplier.agency_number || '',
                    agency_digit: supplier.agency_digit || '',
                    account_number: supplier.account_number || '',
                    account_digit: supplier.account_digit || '',
                    pix_key: supplier.pix_key || ''
                };
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}

export default BankAccount;
